import { useTranslation } from 'react-i18next';
import * as Styled from './TextButton.styled';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Text buttons offer a less prominent option, suitable for less critical actions.
 *
 * ! At the moment, there is no anchor version.
 */
export function TextButton({
  type,
  isLoading,
  disabled,
  children,
  ...rest
}) {
  const {
    t
  } = useTranslation('blocks.buttons');
  return /*#__PURE__*/_jsx(Styled.Button, {
    // "type" and ternary statement necessary to satisfy ESLint
    type: type === 'submit' ? 'submit' : 'button',
    disabled: isLoading || disabled,
    ...rest,
    children: isLoading ? /*#__PURE__*/_jsx(Styled.ShimmerLoader, {
      "aria-label": t('TextButton.ShimmerLoader.ariaLabel', 'Loading'),
      children: /*#__PURE__*/_jsx("span", {
        children: children
      })
    }) : children
  });
}